
<!-- remember wraping divs row container
 and the body class -->


<template>
  <div>
	  <div class="loading" v-if="loading">
   
<div class="loader">
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</div>
    </div>
  <div v-if="fetch">

	<modal name="prdDetails" :adaptive="true" height="auto" :scrollable="true" class="">
		<b-modal v-model="modalShow" ok-only centered centered class="text-center text-info" style="z-index:99999">
		You are not logged in as a user!
		</b-modal>
		<b-modal v-model="modalShow2" ok-only centered centered class="text-center text-info" style="z-index:99999">
		Added To Cart
		</b-modal>
		<b-modal v-model="modalShow3" ok-only centered centered class="text-center text-info" style="z-index:99999">
		Removed from Cart
		</b-modal>
		<div style=" position: relative;">
			<a @click="close()" class="md-close"></a>
		</div>
		<div class="container p-t-45 p-b-60 mobi-m-p-100">
			<div class="row" style="height:480px;">
				<!-- :autoplay="true" :autoplay-timeout="5000" -->
				<carousel-3d style="height:480px;" :border="0" :controls-visible="ctrl" :autoplay="true" :autoplay-timeout="3000">
				<slide :index="0" style="height:auto !important;">
				<div :data-zoom="image" class="zoom">
				<img :src="image" @click="zoom(image)" alt="" >
				</div>
				</slide>
				<slide :index="1" style="height:auto !important;" v-if="otherimgs.length > 0">
				<div :data-zoom="otherimgs[0]" class="zoom" >
				<img :src="otherimgs[0]" alt="">
				</div>
				</slide>
				<slide :index="2" style="height:auto !important;" v-if="otherimgs.length > 1">
				<div :data-zoom="otherimgs[1]" class="zoom" >
				<img :src="otherimgs[1]" alt="">
				</div>
				</slide>
				<slide :index="3" style="height:auto !important;" v-if="otherimgs.length > 2">
				<div :data-zoom="otherimgs[2]" class="zoom" >
				<img :src="otherimgs[2]" >
				</div>
				</slide>
				<slide :index="4" style="height:auto !important;" v-if="otherimgs.length > 3">
				<div :data-zoom="otherimgs[3]" class="zoom">
				<img :src="otherimgs[3]" >
				</div>
				</slide>
			</carousel-3d>
					
				
			</div>
			<div class="container">
			<div class="row">
			<div class="col-sm-12 col-lg-12 p-t-10 p-b-30 mx-auto text-center mobi-m-p-0"  >
					<div class=" p-t-5 p-lr-0-lg mx-auto text-center">
						<h4 class="mtext-105 cl13 js-name-detail p-b-14 pt-2">
							{{formdata.name}}
						</h4>

						<span class="mtext-106 cl13">
							RS {{formdata.price}}
						</span>

						
						
						<!--  -->
						<div class="p-t-33">
							
							

							<div class="flex-w flex-t p-b-10">
								<div class="size-204 m-l-56" >

										<button @click="sharePrd()" style="background-color: #8b2ae5;" class="flex-c-m stext-101 cl0 size-101 bg10 bor1 hov-btn1 mb-3 p-lr-15 trans-04  mx-auto">
									Share
									</button>
									<button v-if="!incart" @click="addToCart()" class="flex-c-m stext-101 cl0 size-101 bg1 bor1 hov-btn1 p-lr-15 mb-3 trans-04  mx-auto text-center">
										Add to Cart
									</button>
									<button v-if="incart" @click="removeCart()" class="flex-c-m stext-101 cl0 size-101 bg1 bor1 hov-btn1 p-lr-25 mb-3 trans-04  mx-auto text-center">
										Remove from Cart
									</button>
									<button @click="cartClicked()" class="flex-c-m stext-101 cl0 size-101 bg10 bor1 hov-btn1 p-lr-15 trans-04  mx-auto">
									View cart
									</button>
								
								</div>
							</div>	
						</div>

						
					</div>
			</div>
			</div>
			</div>

			<div class="bor10 m-t-0 p-t-43 p-b-40" >
				<!-- Tab01 -->
				<div class="tab01">
					<!-- Nav tabs -->
					<ul class="nav nav-tabs" role="tablist">

						<li class="nav-item p-b-10">
							<a class="nav-link active" data-toggle="tab" href="#information" role="tab">Additional information</a>
						</li>
						<li class="nav-item p-b-10">
							<a class="nav-link " data-toggle="tab" href="#description" role="tab">Description</a>
						</li>

						<!-- <li class="nav-item p-b-10">
							<a class="nav-link" data-toggle="tab" href="#reviews" role="tab">Reviews (1)</a>
						</li> -->
					</ul>

					<!-- Tab panes -->
					<div class="tab-content p-t-43">
						<!-- - -->
						<div class="tab-pane fade" id="description" role="tabpanel">
							<div class="how-pos2 p-lr-15-md">
								<p class="stext-102 cl6">
									{{formdata.desc}}
									
								</p>
							</div>
						</div>

						<!-- - -->
						<div class="tab-pane fade active show" id="information" role="tabpanel">
							<div class="row">
								<div class="col-sm-10 col-md-8 col-lg-6 m-lr-auto">
									<!-- <h5 class="mb-2">Network</h5> -->
									
									<ul class="p-lr-28 p-lr-15-sm">
										<li class="flex-w flex-t p-b-7">
											<span class="stext-102 cl3 size-205">
												name
											</span>

											<span class="stext-102 cl6 size-206">
												{{formdata.name}}
											</span>
										</li>
										<li class="flex-w flex-t p-b-7">
											<span class="stext-102 cl3 size-205">
												price
											</span>

											<span class="stext-102 cl6 size-206">
												RS {{formdata.price}}
											</span>
										</li>
										<li class="flex-w flex-t p-b-7">
											<span class="stext-102 cl3 size-205">
												brand/make
											</span>

											<span class="stext-102 cl6 size-206">
												{{formdata.brand}}
											</span>
										</li>
										<li class="flex-w flex-t p-b-7">
											<span class="stext-102 cl3 size-205">
												color
											</span>

											<span class="stext-102 cl6 size-206">
												{{formdata.color}}
											</span>
										</li>
										<li class="flex-w flex-t p-b-7">
											<span class="stext-102 cl3 size-205">
												condition
											</span>

											<span class="stext-102 cl6 size-206">
												{{formdata.condition}}
											</span>
										</li>
										<li class="flex-w flex-t p-b-7">
											<span class="stext-102 cl3 size-205">
												warranty
											</span>

											<span class="stext-102 cl6 size-206">
												{{formdata.warranty}}
											</span>
										</li>
										<li class="flex-w flex-t p-b-7"
											v-for="(value, key) in formdata.details" :key="key" v-if="value != ''">
											<span class="stext-102 cl3 size-205" v-if="key != 'enginecapacity' && key != 'enginetype' && key != 'fueltype'
											 && key != 'bodytype' && key != 'cpugeneration'">
												{{key}}
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'enginecapacity'">
												engine capacity
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'bodytype'">
												body type
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'enginetype'">
												engine type
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'fueltype'">
												fuel type
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'cpugeneration'">
												cpu generation
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'model'|| key == 'size' || key == 'material'
											 || key == 'modelcode' || key == 'year' || key == 'enginetype' || key == 'fueltype' || key == 'transmission'
											 || key == 'bodytype' || key == 'publisher' || key == 'orthor' || key == 'metal' || key == 'cpugeneration' || key == 'os' || key == 'cpu'">
												{{value}}
											</span>

											<span class="stext-102 cl6 size-206" v-if="key == 'storage'|| key == 'ram' || key == 'hard'
											 || key == 'graphics'">
												{{value}} GB
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'frontcamera'|| key == 'rearcamera'">
												{{value}} MP
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'screen'|| key == 'screensize'">
												{{value}} inches
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'karat'">
												{{value}} k
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'weight'">
												{{value}} g
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'battery'">
												{{value}} mAh
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'enginecapacity'">
												{{value}} cc
											</span>
											<span class="stext-102 cl6 size-206" v-if="key == 'mileage'">
												{{value}} km
											</span>
										</li>
									</ul>
								</div>
							</div>
						</div>

						<!-- - -->
						
					</div>
				</div>
			</div>
		</div>
  		
	</modal>

	<!-- Product -->
	<div class="p-b-50">
		<div class="container">
			<div class="flex-w flex-sb-m">
				
				
				<!-- Search product -->
				<!-- <div class="panel-search w-full p-t-10">
					<div class="bor8 dis-flex p-l-15">

						<input class="mtext-107 cl2 size-114 plh2 p-r-15" style="height: 40px;" type="text" name="search-product" :placeholder=" ' Search in ' + $route.params.cat " v-model="search" @keydown="clickSearch()">
					</div>	
				</div>
				<div class="flex-w flex-c-m bor8 sugdiv" :style="{display: suggestion}">
				<ul  class="sug" v-if="search.length >= 2">
					<li class="" v-for=" (item, i) in filteredProducts" :key="item.id" style="cursor:pointer;" @click="setSearch(item.name)">{{item.name}}</li>
				</ul>
				</div> -->
				<div class="flex-w flex-c-m m-tb-10 m-t-70 m-filter"  style="width:100%; z-index:1099;">
					<div class="flex-c-m stext-106 cl6  bor4 pointer filter-btn trans-04 m-r-8 m-tb-4"  style="position:fixed;  z-index:1099; height:40px; width:284px;" @click="disFilter()">
						<i class="icon-filter cl2 m-r-6 fs-15 trans-04 zmdi zmdi-filter-list"></i>
						<!-- <i class="icon-close-filter cl2 m-r-6 fs-15 trans-04 zmdi zmdi-close dis-none"></i> -->
						All Categories & Filters
					</div>
				</div>
				<!-- Filter -->
				<div class="panel-filter w-full" :style="{display: dismobi}">
					<div class="wrap-filter flex-w bg6 p-lr-40 p-t-27 p-lr-15-sm">
						<div class="filter-col1 p-r-15 p-b-27 col-sm-12">
							<div class="mtext-102 cl2 p-b-15">
								Sort By
							</div>

							<ul>
								
								<li class="p-b-6">
									<a @click="sortPriceLTH()" class="filter-link stext-106 trans-04">
										Price: Low to High
									</a>
								</li>

								<li class="p-b-6">
									<a @click="sortPriceHTL()" class="filter-link stext-106 trans-04">
										Price: High to Low
									</a>
								</li>
							</ul>
							<div class="mtext-102 cl2 p-b-15">
								Categories
							</div>
							<ul >
								<li v-for="(values , key) in shopcats" :key="key" class="main-nav-list  child mb-3"><span class="mb-3 text-info">{{key}}</span>
								<ul>
								<li class="main-nav-list py-1 ml-1 sidesubcat" v-for="(value , key) in values" :key="key" v-if="value > 0"><span @click="collapseItem(key)"  style="cursor:pointer;">{{key}} ({{value}})</span>
								</li>
								</ul>
								</li>
								<!-- <li class="main-nav-list pb-3 pl-2 child text-info" style="cursor: pointer;" @click="maincat(category)"><span>All {{category}}</span></li>
								<li class="main-nav-list py-1"  v-for="(category, i) in categoriesList" :key="i" style="cursor:pointer;" @click="collapseItem(i)"><a>{{category}}</a></li> -->
								
							</ul>
						</div>

						
					</div>
				</div>
			</div>
		
		
		
			<div class="row">
			
                <!--side-menu-->
				<div class="col-md-3 col-lg-2 p-b-30 ">
				 <!-- <StoreSidebar/> -->
				  <div>
      <!--side-menu-->
			
			
					<div class="side-menu m-t-30">
						
						<div class="p-t-10 sidebar-categories">
							<h4 class="mtext-112 cl2 p-b-10">
								Sort By
							</h4>
							<ul>
								
								<li class="p-b-6">
									<a @click="sortPriceLTH()" class="filter-link stext-106 trans-04 p-l-8">
										<span style="cursor: pointer;"> Price: Low to High</span>
									</a>
								</li>

								<li class="p-b-6" >
									<a @click="sortPriceHTL()" class="filter-link stext-106 trans-04 p-l-8">
									<span style="cursor: pointer;"> Price: High to Low</span>
									</a>
								</li>
							</ul>
							<h4 class="mtext-112 cl2 p-b-20 p-t-16">
								Categories
							</h4>

							<ul >

								<li v-for="(values , key) in shopcats" :key="key" class="main-nav-list  child mb-3"><span class="mb-3 text-info">{{key}}</span>
								<ul>
								<li class="main-nav-list py-1 ml-1 sidesubcat" v-for="(value , key) in values" :key="key" v-if="value > 0"><span @click="collapseItem(key)"  style="cursor:pointer;">{{key}} ({{value}})</span>
									
								</li>
								</ul>
								</li>
							</ul>
						</div>
					</div>
				
			
  </div>
				</div>
			<div class="col-md-9 col-lg-10 justify-item-center m-t-50 mobi-m-t-10">
			
			<div class="row isotope-grid">
				<template v-for=" (item, i) in filteredProducts.slice(0, items)" > 
					<div class="col-6 col-sm-4 col-md-4 col-lg-3 p-b-35 isotope-item men" v-bind:key="item.id" >
					<!-- Block2 -->
					<div class="block2 " style="box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);">
						<div class="block2-pic hov-img0" >
							<div :src="item.image" class="zoom">
							<!-- <router-link :to="{name: 'storeproductdetails', params:{id: item.id}}" > -->
								<img :src="item.image" style="cursor:pointer;" @click="show(item)" alt="PRODUCT-IMAGE">
							<!-- </router-link> -->
							</div>
							
						</div>

						<div class="block2-txt flex-w flex-t p-t-14" style="padding: 20px;background-color: #ffffff;">
							<div class="block2-txt-child1 flex-col-l ">
								<router-link :to="{name: 'storeproductdetails', params:{id: item.id}}" class="stext-104 cl6 hov-cl13 text-info trans-04 m-txt js-name-b2 p-b-6" 
								style="font-size: 16px; font-weight: 500;">
									{{item.name}}
								</router-link>

								<span class="stext-105 cl3" v-if="(item.disprice != item.price )">
									<span class="stext-105 cl15 m-txt" style="color:#F03B3B; display:block;">RS {{item.price}}</span>
									<span class="stext-105 cl3 m-txt" style="text-decoration: line-through;">
									RS {{item.disprice}}
									</span>
								</span>
								<span class="stext-105 cl3 text-info m-txt" v-if="(item.disprice == item.price )">
									RS {{item.price}}
								</span>
								<!-- <span class="stext-105 cl3">
								 {{item.color}}
								</span> -->
							</div>

							<div class="block2-txt-child2 flex-r p-t-3">

								
							</div>
						</div>
					</div>
				</div>
				</template>
			
			</div>

			<!-- Load more -->
			<div class="flex-c-m flex-w w-full p-t-45">
				<!-- <button  @click="lessItems()"  v-if="items !== 25 && items > 25" class="flex-c-m stext-101 cl5 size-103 bg2 bor1 hov-btn1 p-lr-15 trans-04">
					Show Less
				</button>
				<button  @click="moreItems()" v-if="dismore !== undefined || items < maxitems" class="flex-c-m stext-101 cl5 size-103 bg2 bor1 hov-btn1 p-lr-15 trans-04">
					Show More
				</button> -->
				<!-- <button  @click="moreItems()" v-if="dismore !== undefined" class="flex-c-m stext-101 cl5 size-103 bg2 bor1 hov-btn1 p-lr-15 trans-04">
					Show More
				</button> -->
				 <div class="block">
 			 </div>
			</div>
			</div>
			</div>
		</div>
	</div>
  </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit"
import firebase from 'firebase/app';
import {bus } from "../../main"
import mobiles from '../../data/mobiles'
import ClothingAccessories from '../../data/ClothingAccessories'
//import shopCat from '../../data/shopCat'
export default {
  name: 'products',
  components: {
  },

  data (){
    return{
		loading: false,
     	fetch: false,
		 currentPage4: 4,
		 modalShow: false,
		 modalShow2: false,
		 modalShow3: false,
		 checkval: false,
		 users:[],
		products: [],
		cartItems:0,
		visible: 'block',
		visible1: 'none',
		category: this.$route.query.cat,
		 image:'',
		 otherimgs:[],
		  cartitems:[],
		  ctrl:true,
		  incart:false,
		  isLoggedIn: false,
		  currentUser: false,
		  isCartItem:'',
		  cartPrdIDs:[],
		  width:'75%',

		 display: "none",
		 suggestion: 'none',
		  openedItems: {},
		  categoriesList: [],
		  subcategories:this.$route.query.cat,
		  subcat: [],
		  shops: [],
		  allProducts: [],
		  shopcat:{},
		  shopcats:{},
		  chngcat:'',
		 
		 cartclr: '#7ED7F8',
		  search: '',
		lastVisible: '',
		items:100000,
		dismore:'',
		maxitems: 100000,
		sidecat:'',
		dismobi:'none',
		plan:'',

		 formdata: {
			 		id:'',
          name: '',
          price:'',
          dis: 0,
          disprice: 0,
          brand: '',
          color: '',
		  cond:'',
		  warranty:'',
          desc: '',
          image: null,
          imageUrl: "",
          imageUrl2:'',
          imageUrl3:'',
          owner:'',
          
         
          model:'',
          cpu:'',
          cpugen:'',
          hard:'',
          storage:'',
          ram:'',
          graphics:'',
          screen:'',
          rearcamera:'',
          frontcamera:'',
          os:'',
          battery:'',
		  weight:'',
		  
		  details:{}
         
        },
		
    }
  },
  computed: {
    filteredProducts: function(){
		//console.log('filprd:')
		 
          return this.products.filter( (product) => {
            //   this.lowerCase(product.name)
            //   this.lowerCase(this.search)
			//console.log('filfkkk')
			// //console.log('sidecat', this.sidecat)
			// if(this.sidecat !== null){
			// 	 return product.subcategory.match(this.sidecat)
			// }else{
				 return product.name.match(this.search)
			//}
             
          })
		  
      },
  },
  
  mounted () {
	 if(firebase.auth().currentUser){
		 
			this.$store.state.secondaryDatabase.collection('carts').where('uid', '==', firebase.auth().currentUser.uid)
			.where('shopid', '==', this.$route.params.storename).get()
			.then(querySnapshot => {
			querySnapshot.forEach(doc => {
			const data = {
				'id': doc.id,
				'prdid': doc.data().prdid
			}
			this.cartitems.push(data)
			this.cartItems = this.cartitems.length
			this.cartPrdIDs = this.cartitems.map((citem) => citem.prdid)
			//console.log('this.cartitems',this.cartitems)
			//console.log('this.cartPrdIDs',this.cartPrdIDs)
		})
		// var findCartItem = function(citem, id){
		// 	var findedid = citem.find((ci, index) => {
		// 		return ci == id
		// 	})
		// 	return findedid
		// }
		// if(this.cartPrdIDs != undefined){
		// 	this.isCartItem = findCartItem(this.cartPrdIDs, this.$route.params.id)
		// }
		// //console.log('isCartItem',this.isCartItem)

		// if(this.isCartItem == this.$route.params.id){
			
		// }
		})
		  
	  }
	  
  },
  created(){
       this.$nextTick(function() { 
		 this.initToTopButton();
		//  $('.zoom').zoom();
	})
	  if(screen.width > 575){
        this.width = '100%'  
      }
//   },
//    beforeCreate () {
		this.loading = true
		  this.fetch = false
		  this.backToTop()
	    this.$store.state.secondaryDatabase.collection('shops').where('owner', '==', this.$route.params.storename).get()
      .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        const data = {
			'id':doc.id,
			'categories':doc.data().categories,
		  'shoptype' : doc.data().shoptype,
		  'plan':doc.data().plan,
          
        }
		this.shops.push(data)
		this.shopcats = this.shops[0].categories
		this.plan = this.shops[0].plan
          //console.log(this.shops[0].shoptype)
      })
     }) 

		var cat = this.$route.params.cat
		if( !this.$store.state.products[this.$route.params.storename]){
			 this.$store.state.products[this.$route.params.storename] = {}
			 //console.log('store obj created', this.$store.state.products[this.$route.params.storename])
		}
		
		 //console.log(this.$store.state.products)
		//console.log('condition is ', this.$store.state.products[this.$route.params.storename][this.$route.params.cat])
		 if(this.$store.state.products[this.$route.params.storename][this.$route.params.cat] != undefined){
			 
			 this.allProducts = this.$store.state.products[this.$route.params.storename][this.$route.params.cat]
			this.products = this.allProducts 
			this.shopcat[cat] = this.products
			//console.log('this.shopcat[this.$route.query.cat]', this.shopcat[this.$route.params.cat])
			//console.log(this.products)
			//console.log('products from store!!!')
			this.loading = false
     		 this.fetch = true
		 }else {
			
			this.$store.state.secondaryDatabase.collection("products").where("subcat", "==", this.$route.params.cat)
			.where("owner", "==", this.$route.params.storename).get()
			.then((snapshot) => {
			this.allProducts = []
			snapshot.forEach( doc => {
				const data = {
			'id' : doc.id, 
			'color': doc.data().color ,
			'name': doc.data().name, 
			'price': doc.data().price,
			'disprice': doc.data().disprice,
			'image': doc.data().img,
			'subcat' : doc.data().subcat ,

			'brand' : doc.data().brand,
			'cond' : doc.data().cond,
        	'warranty': doc.data().war,
		  'desc' : doc.data().desc,
		  'details' : doc.data().details,
		  'otherimgs' : doc.data().otherimgs,
			barcode:  doc.data().barcode,
			      
			}
			this.allProducts.push(data)
			this.products = this.allProducts 
			this.shopcat[cat] = this.products
			this.$store.state.products[this.$route.params.storename][cat] = this.products
			//console.log('this.shopcat[this.$route.query.cat]', this.shopcat[this.$route.params.cat])
			//console.log(this.products)
			//console.log('shop cat from for each', this.shopcat)
			})
			this.loading = false
     		 this.fetch = true
			//console.log('shop cat from', this.shopcat)
			// this.lastVisible = snapshot.docs[snapshot.docs.length-1];
  			// //console.log("last", this.lastVisible);
			//   //console.log("prd color", this.products[0].color);
			//    if(snapshot.docs.length < 25){
			// 	  this.lastVisible = undefined
  			// 		//console.log("last", this.lastVisible);
			// 		  this.dismore = undefined
  			// 		//console.log("dismore", this.dismore);
			// 		  this.maxitems = this.products.length
			// 		  //console.log("maxitems", this.maxitems);
			//   }
			
			// snapshot.docChanges().forEach(function(change) {
			// 	if (change.type === "added") {
			// 		//console.log("New city: ", change.doc.data());
			// 	}

			// 	var source = snapshot.metadata.fromCache ? "local cache" : "server";
			// 	//console.log("Data came from " + source);
			// });
		});
		 }
 
	//    //console.log('this.products')
    //   db.collection('products').where("category", "==", this.$route.query.cat)
    //   .get()
    // .then(querySnapshot => {
    //   querySnapshot.forEach(doc => {
	// 	  //console.log('this.products')
    //     const data = {
    //       'id' : doc.id,
    //       'name': doc.data().name,
	// 	  'price': doc.data().price,
	// 	  'image': doc.data().imageUrl
    //     }
    //     this.products.push(data)
    //     //console.log(this.products)
          
    //   })
    // })
  },

  methods: { 
	//   zoom(image){
	// 	//   this.$zoom(image);
	//   },
		sharePrd(){
			if(navigator.share){
          navigator.share({
              title: this.formdata.name,
              text: this.formdata.desc,
              url: 'https://eshops.lk/#/stores/'+this.$route.params.storename+'/productdetails/'+this.formdata.id
          })
            .then(() => {
              alert('Successful share')
              })
            .catch((error) => {
              alert('Error sharing ' +error)
              });
          }else{
              var url = 'https://eshops.lk/#/stores/'+this.$route.params.storename+'/productdetails/'+this.formdata.id
              alert("Web Share is not supported by this browser. You can copy this link and share it. Link - "+ url)
          }
		},
	  close(){
		  this.$modal.hide('prdDetails')
	  },
	  show(item){
		  //console.log('showmodal clixkes')
			var findCartItem = function(citem, id){
			var findedid = citem.find((ci, index) => {
				return ci == id
			})
			return findedid
			}
			if(this.cartPrdIDs != undefined){
				this.isCartItem = findCartItem(this.cartPrdIDs,item.id)
				if(this.isCartItem == item.id){
					this.incart = true
				}else{
					this.incart = false
				}
			}else{
				this.incart = false
			}
			
			//console.log('isCartItem',this.isCartItem)

		  this.prdID = item.id
		   this.otherimgs = item.otherimgs
		   //console.log('this.otherimgs',this.otherimgs)
			this.image = item.image
			this.formdata.id = item.id
			 this.formdata.name = item.name
          this.subcategory = item.subcat
          this.formdata.brand = item.brand
          this.formdata.price = item.price
         // this.formdata.dis = item.dis
          this.formdata.color = item.color
		   this.formdata.condition = item.cond
			 this.formdata.barcode = item.barcode,
        	this.formdata.warranty = item.warranty
          this.formdata.desc = item.desc
		  this.formdata.details = item.details
		  if(this.otherimgs == undefined || this.otherimgs.length == 0){
			  this.ctrl = false
		  }else if(this.otherimgs.length > 0){
			  this.ctrl = true
		  }
		  this.$modal.show('prdDetails')
	  },
	  	 cartClicked(){
		  if(!firebase.auth().currentUser){
			  this.modalShow = true
		  }else if(firebase.auth().currentUser){
			  this.cartlink = true
			  this.$router.push({name: 'storecart', params:{storename: this.$route.params.storename}})
		  }
	  },

	 addToCart() {
		  //console.log('added to cart')
		 
		
		if(!firebase.auth().currentUser){
			this.modalShow = true
		}
		if(firebase.auth().currentUser){
        // if(firebase.auth().currentUser.displayName != 'shop owner'){
			// if(this.isCartItem != this.$route.params.id){
			// this.cartclr = 'green'
			//this.isCartItem = this.$route.params.id
			this.modalShow2 = true
			this.cartPrdIDs.push(this.prdID)
			this.incart = true
		  //console.log('checked')
		  this.$store.state.secondaryDatabase.collection("carts")
        	.add({
              uid: firebase.auth().currentUser.uid,
			  shopid: this.$route.params.storename,
			  prdid: this.prdID,
			  prdname: this.formdata.name,
				barcode: this.formdata.barcode,
			  quantity: 1,
              price: this.formdata.price,
              total: this.formdata.price,
             img: this.image
             
			})
			.then(doc => {
				
				this.cartItems += 1
				bus.$emit('cartChanged', this.cartItems)
				this.$store.state.cartItems[this.$route.params.storename] += 1
				//console.log(doc.id)
				//console.log('store cart',this.$store.state.cartItems[this.$route.params.storename])
			})
			.catch(error => alert('An error is occured!!!'));
		// }else if(this.isCartItem == this.$route.params.id){
		// 	this.modalShow3 = true
		// }
		
		// }else if(firebase.auth().currentUser.displayName == 'shop owner'){
		// 	this.modalShow = true
		// 	this.checkval = false
		// }
		}
		// else if(firebase.auth().currentUser && !firebase.auth().currentUser.emailVerified){  
		// 	this.modalShow = true
		// }	 
	  },	

	  removeCart(){
		  var newcartPrdIDs = this.cartPrdIDs.filter((citem) => {
				return citem !== this.prdID
				})
				this.incart = false
			  this.modalShow3 = true
			  this.cartPrdIDs = newcartPrdIDs
			  //console.log("this.cartPrdIDs", this.cartPrdIDs)
            this.$store.state.secondaryDatabase.collection("carts").where('prdid', '==', this.prdID )
			.where('uid', '==', firebase.auth().currentUser.uid ).get()
			.then(querySnapshot => {
				querySnapshot.forEach(doc => {
					//console.log('doc id',doc.id)
					 this.$store.state.secondaryDatabase.collection("carts").doc(doc.id).delete().then(() => {
						 	this.cartItems -= 1
							bus.$emit('cartChanged', this.cartItems)
							this.$store.state.cartItems[this.$route.params.storename] -= 1
              				//console.log('cart item deleted')
					})
					 .catch(error => alert(error));
				})
				
				}) 
            .catch(error => alert(error));
	  },

	  initToTopButton: function() {
		$(document).bind('scroll', function() {
			var backToTopButton = $('.goTop');
			if ($(document).scrollTop() > 100) {
			backToTopButton.addClass('isVisible');
			this.isVisible = true;
			} else {
			backToTopButton.removeClass('isVisible');
			this.isVisible = false;
			}
		}.bind(this));
     },
    backToTop: function() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'fast', 'swing');
    },

	  disFilter(){
		  //console.log('disfiltr', this.dismobi)
		  if(this.dismobi == 'none'){
			return  this.dismobi = 'block'
		  }
		   if(this.dismobi == 'block'){
			return  this.dismobi = 'none'
		  }
	  },
	  colorSort(){
		//console.log('clrsort:')
		 
        this.products = this.products.filter( (product) => {
            //   this.lowerCase(product.name)
            //   this.lowerCase(this.search)
			//console.log('filfkkk')
              return product.color == 'black'
          })
		  
	  },
	  sortPriceLTH(){
		  //console.log('clicked price')
		  this.dismobi = 'none'
		  this.backToTop()
		 this.products.sort(function(a,b){
			//   //console.log('clicked price again')
			  return a.price - b.price
			  
		  })
		  //console.log('clicked price agin', this.filteredProducts)
		  
	  },
	  sortPriceHTL(){
		  this.dismobi = 'none'
		   this.backToTop()
		  //console.log('clicked price')
		 this.products.sort(function(a,b){
			//   //console.log('clicked price again')
			  return a.price - b.price
			  
		  }).reverse()
		  //console.log('clicked price again', this.filteredProducts)
		  
	  },
	  setSearch(name){
		  this.search = name
		  this.suggestion = 'none'
	  },
	  clickSearch(){
		  //console.log('length',this.search.length)
		  if(this.search.length == 0){  
		  this.products = this.$store.state.products[this.$route.params.storename][this.$route.params.cat]
		  }
		  this.suggestion = 'block'
	  },

	//   maincat(){
	// 	  this.dismobi = 'none'
	// 	   this.backToTop()
	// 	  this.products = this.allProducts
	//   },	
	  	moreItems(){
		  if(this.lastVisible != undefined){
		  this.$store.state.secondaryDatabase.collection("products").where("cat", "==", this.category)
       .where("owner", "==", this.$route.params.storename)
	   .startAfter(this.lastVisible)
	   .limit(25)
		.onSnapshot((snapshot) => {
			snapshot.forEach( doc => {
				const data = {
			'id' : doc.id, 
			'name': doc.data().name, 
			'price': doc.data().price,
			'disprice': doc.data().disprice,
			'image': doc.data().img,
			'shopID': doc.data().shopID,
			'color': doc.data().color,
			      
			}
			this.products.push(data) 
			//console.log(this.products)
			})
			this.lastVisible = snapshot.docs[snapshot.docs.length-1];
			  //console.log(" moreitems last", this.lastVisible);
			  //console.log(" moreitems snapshot.length", snapshot.docs.length);
			  if(snapshot.docs.length < 25){
				  this.lastVisible = undefined
  					//console.log("last", this.lastVisible);
					  this.dismore = undefined
  					//console.log("dismore", this.dismore);
					  this.maxitems = this.products.length
					  //console.log("maxitems", this.maxitems);
			  }
			
			})
		  }
		  this.items += 25
		  //console.log('moreitems items', this.items)
		  //console.log("mritms maxitems", this.maxitems);
	  },
      lessItems(){
		   this.items -= 25
		  //console.log(this.items)
	  },

	   collapseItem(subcat) {
		  this.dismobi = 'none'
		  this.loading = true
     	 this.fetch = false
		  
		  // this.products = []
		  this.search = ''
		   ////console.log(this.categoriesList[n])
		  // this.products = this.allProducts
		   // //console.log(this.products)
		//    this.sidecat = this.categoriesList[n]
		//    //console.log('sidecat', this.sidecat)

		//console.log('clrsort:')
		 
        // this.products = this.products.filter( (product) => {
        //     //   this.lowerCase(product.name)
        //     //   this.lowerCase(this.search)
		// 	//console.log('product subcat', product.subcat)
        //       return product.subcat == this.categoriesList[n]
        //   })


		if(this.$store.state.products[this.$route.params.storename][subcat]){
			this.products = []
			this.$route.params.cat = subcat
			//console.log('route cat', this.$route.params.cat)
			this.products = this.$store.state.products[this.$route.params.storename][subcat]
			 this.backToTop()
			//console.log('products from fetched data')
			this.$route.params.cat = subcat
			this.$router.replace({ name: 'storeproducts', params: { storename: this.$route.params.storename, cat:subcat }})
			this.loading = false
     	 	this.fetch = true
			//console.log('route cat', this.$route.params.cat)
		}else{
			this.backToTop()
		 this.$store.state.secondaryDatabase.collection("products").where("subcat", "==", subcat)
		  .where("owner", "==", this.$route.params.storename).get()
		.then((snapshot) => {
			this.products = []
			snapshot.forEach( doc => {
				const data = {
			'id' : doc.id, 
			'color': doc.data().color ,
			'name': doc.data().name, 
			'price': doc.data().price,
			'disprice': doc.data().disprice,
			'image': doc.data().img,
			'subcat' : doc.data().subcat ,

			'brand' : doc.data().brand,
			'cond' : doc.data().cond,
        	'warranty': doc.data().war,
			'desc' : doc.data().desc,
			'details' : doc.data().details,
			'otherimgs' : doc.data().otherimgs,      
			}
			this.products.push(data) 
			this.shopcat[subcat] = this.products
			this.$store.state.products[this.$route.params.storename][subcat] = this.products
			
			})
			this.$route.params.cat = subcat
			
			this.$router.replace({ name: 'storeproducts', params: { storename: this.$route.params.storename, cat:subcat }})
			this.loading = false
     	 	this.fetch = true
			//console.log('route cat', this.$route.params.cat)
			//console.log(this.products)
			//console.log( 'prds')
			this.$route.params.cat = subcat
			//console.log('route cat', this.$route.params.cat)
		})
		}
		
    },

      handleSizeChange(val) {
        //console.log(`${val} items per page`);
      },
      handleCurrentChange(val) {
        //console.log(`current page: ${val}`);
	  },
	 
    }
}
</script>

<style scoped>

 @import url('~@/assets/main/css/loading.css');
.search-result {
  padding: 12px;
  margin-bottom: 40px;
  margin-top: 0px;
}

.search-result p {
  margin: 0;
}

.bg-gray {
  background: #F5F5F5;
}
.sug{
	 height: 150px;
	 overflow-y: scroll;
	 padding-left: 25px;
	 
}
.sugdiv{
	width: 100%;
} 
.m-filter{
	visibility: hidden;
	display: none;
}
.zmdi-shopping-cart{
	font-size: 30px;
	visibility: visible;
}
.sidesubcat:hover{
	color: blue;
	text-decoration: underline;
}
.v--modal-overlay {
  background: rgb(0, 0, 0,0.8);
  z-index: 99998;
}
.md-close {
  position: absolute;
  right: 16px;
  top: 16px;
  width: 32px;
  height: 32px;
  opacity: 0.7;
  cursor: pointer;
}
.md-close:hover {
  opacity: 1;
}
.md-close:before, .md-close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #333;
}
.md-close:before {
  transform: rotate(45deg);
}
.md-close:after {
  transform: rotate(-45deg);
}

@media (max-width: 767px){   
	.side-menu {
		display: none;
		
	}
	.m-filter{
		visibility: visible;
		display: inline-flex;	
	}
	.panel-filter{
		position: fixed;
		z-index: 1099;
		margin-top: 266px;
		width: 98%;
		/* height: 400px;
		overflow-y: scroll; */
	}
	.filter-col1{
		height: 400px;
		overflow-y: scroll;
	}
	.wrap-filter{
		width: 98%;
	}
	.panel-search {
		display: none;
	}
	.m-txt{
	  color:#6c7ae0;
	 
	}
	.mobi-m-t-10{
		margin-top: 10px;
	}
	.mobi-m-p-100{
		padding-top: 75px;
	}
	.mobi-m-p-0{
		padding-top:0px;
	}
}
@media (max-width: 575px){
	.zmdi-shopping-cart{
		font-size: 18px;
	}
	.m-txt{
		font-size: 12px;
		line-height: 1.0;
	  letter-spacing: 0px;
	  color:#6c7ae0;
	 
	}
	.wrap-filter{
		width: 94%;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/store/Products.vue